<template>
	<div class="submenu-container">
		<span class="mobile-dropdown" :class="{ active }" @click="active = !active">
			<font-awesome-icon :icon="`fal fa-chevron-down`" size="1x" />
		</span>
		<div class="submenu" :class="{ active: hideAll ? resetState() : active }">
			<ul>
				<li v-for="item in subitems" :key="item.filename">
					<nuxt-link :to="`${item.filename}`" @click="hideMenu">
						{{ item.header }}
					</nuxt-link>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
defineProps({
	subitems: { type: Array, default: () => [] },
	hideAll: { type: Boolean, default: false },
});

const emit = defineEmits(['hide-nav']);

const active = ref(false);

const resetState = () => {
	active.value = false;
};

const hideMenu = () => {
	emit('hide-nav');
};
</script>

<style lang="scss" scoped>
.submenu-container {
	position: relative;
}

a {
	font-weight: 400;
	text-transform: uppercase;

	&.active,
	&:hover {
		color: var(--cta-color);
	}
}

.mobile-dropdown {
	display: none;
	width: 20px;
	height: 16px;
	margin: 0 -20px 3px 12px;
	transform-origin: bottom;

	&.active {
		transform: rotate(180deg);
	}
}

.submenu {
	ul {
		display: none;
		background: var(--secondary-background-color);
		text-align: left;
		padding: 7px;

		&.active {
			display: block;
		}

		li {
			padding: 2px 0;
			list-style: none;

			a {
				margin: 0 10px;
				text-decoration: none;
				font-size: 20px;
				font-weight: 200;
				letter-spacing: 1px;
				font-family: var(--heading-font-family);
			}
		}
	}

	&.active ul {
		display: block;
	}
}

@media (min-width: 1081px) {
	.hassubmenu:hover {
		.submenu {
			ul {
				display: block;
			}
		}
	}
}

@media (max-width: 1080px) {
	.mobile-dropdown {
		display: inline-block;
	}

	.submenu-container {
		display: inline;
	}

	.submenu {
		ul {
			li {
				a {
					font-size: 22px;
				}
			}
		}
	}
}
</style>
